import {useEffect, useLayoutEffect, useState} from "react";

function getBrowserFullscreenElProp() {
  if (typeof document.fullscreenElement !== "undefined") {
    return "fullscreenElement";
  } else if (typeof document.mozFullscreenElement != "undefined"){
    return "mozFullscreenElement";
  } else if (typeof document.msFullscreenElement != "undefined"){
    return "msFullscreenElement";
  } else if (typeof document.webkitFullscreenElement != "undefined"){
    return "webkitFullscreenElement";
  } 
  throw new Error("fullscreenElement is not supported");
}

const useFullscreenStatus = (elRef) => {
  const [isFullscreen, setIsFullscreen] = useState(document[getBrowserFullscreenElProp()] != null);

  useEffect(() => {
    
    if (!elRef.current || !isFullscreen) return;
    elRef.current.requestFullscreen().then(() => {
      setIsFullscreen(document[getBrowserFullscreenElProp()] != null);
    }).catch(() => {
      setIsFullscreen(false);
    });
  }, [elRef.current, isFullscreen]);
  
  useLayoutEffect(() => {
    document.onfullscreenchange = () => 
      setIsFullscreen(document[getBrowserFullscreenElProp()] != null);
  
    return () => {
      document.onfullscreenchange = undefined;
    };
  });

  return [isFullscreen, setIsFullscreen];
};

export default useFullscreenStatus;